import { render } from "./bookingInfo.vue?vue&type=template&id=dd2b1f5e&scoped=true"
import script from "./bookingInfo.vue?vue&type=script&lang=js"
export * from "./bookingInfo.vue?vue&type=script&lang=js"

import "./bookingInfo.vue?vue&type=style&index=0&id=dd2b1f5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2b1f5e"]])

export default __exports__